import { SpoNatureFullResponse } from '@spo/types';
import { VpButton, VpIcon, VpSticker } from '@vtmn-play/react/headless';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoles } from '../../../../contexts/RolesContext';
import { CreateUserNeedForm } from '../../../CreateUserNeedForm/CreateUserNeedForm';
import { ProductBenefits } from '../../../productBenefits';
import '../drawer-nature.scss';
import './drawer-tab-user-need.scss';

export const DrawerTabUserNeed = ({
  nature,
  openExitSettingsModal,
  setOpenExitSettingsModal,
  setFormIsEmpty,
}: {
  nature: SpoNatureFullResponse;
  openExitSettingsModal: boolean;
  setOpenExitSettingsModal: (value: boolean) => void;
  setFormIsEmpty: (value: boolean) => void;
}) => {
  const [openDrawerAddUserNeeds, setOpenDrawerAddUserNeeds] = useState(false);
  const { t } = useTranslation();
  const { hasRoleSportLeader, hasRoleProductLeader } = useRoles();

  const sortedUserNeeds = nature.userNeeds
    ? [...nature.userNeeds].sort((a, b) =>
        a.isDeprecated === b.isDeprecated ? 0 : a.isDeprecated ? 1 : -1,
      )
    : [];

  return openDrawerAddUserNeeds ? (
    <CreateUserNeedForm
      setOpenDrawerAddUserNeeds={setOpenDrawerAddUserNeeds}
      openExitSettingsModal={openExitSettingsModal}
      setOpenExitSettingsModal={setOpenExitSettingsModal}
      setFormIsEmpty={setFormIsEmpty}
    />
  ) : (
    <>
      {(hasRoleSportLeader || hasRoleProductLeader) && (
        <VpButton
          className="drawer-create-user-need-button"
          data-testid="drawer_create_user-need_button"
          shape="squared"
          onClick={() => setOpenDrawerAddUserNeeds(true)}
        >
          <VpIcon name="add" />
          {t('architecture.drawer.user-need.create')}
        </VpButton>
      )}
      {nature.userNeeds ? (
        <div
          className="drawer-tab-user-need-container"
          data-testid="drawer-tab-user-need-container"
        >
          <div className="needs-count">{`(${nature.userNeeds.length} ${t('architecture.drawer.user-need.needs-label')})`}</div>
          {sortedUserNeeds.map((userNeed) => (
            <div className="need-container" key={userNeed.id}>
              <div className="need-name">
                <span className="formatted-text">
                  {userNeed.nameEn.toLowerCase()}
                </span>
                {!userNeed.usageSegmentationType?.label &&
                  !userNeed.usageSegmentationValue?.label && (
                    <VpSticker variant="secondary">
                      {t('architecture.drawer.user-need.no-usage-seg')}
                    </VpSticker>
                  )}
                {userNeed.usageSegmentationType?.label && (
                  <VpSticker variant="secondary">
                    {userNeed.usageSegmentationType?.label}
                  </VpSticker>
                )}
                {userNeed.usageSegmentationValue?.label && (
                  <VpSticker variant="secondary">
                    {userNeed.usageSegmentationValue?.label}
                  </VpSticker>
                )}
              </div>
              {userNeed.isDeprecated && (
                <div className="need-deprecated">
                  <VpSticker variant="catchy">Deprecated</VpSticker>
                </div>
              )}
              <div
                className={clsx('need-content', {
                  deprecated: userNeed.isDeprecated,
                })}
              >
                <div className="need-description">{userNeed.descriptionEn}</div>
                <ProductBenefits benefits={userNeed.productBenefits} inline />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="drawer-empty-config">
          {t('architecture.drawer.empty-configuration')}
        </div>
      )}
    </>
  );
};
